import styled from "styled-components/macro";
import media from "../../constants/MediaQuery";
import Typography from "../../atoms/typography";
import Button from "../../atoms/Button";
import { DPIconCircleRightArrow } from "../../assets/icons";
// import Emage from "./emage";
// import BtnFeatures from "./btnFeatures";
import Modal from "../../atoms/Modal";
import { useState } from "react";
import { BecomeAnAgentForm } from "../../atoms/BecomeAnAgentForm";
import { motion } from "framer-motion";

const BecomeAnAgent = () => {
  const [showAggregatorForm, setShowAggregatorForm] = useState(false);

  let leftVariant = {};
  let rightVariant = {};

  const isMobile = window.innerWidth < 768;

  if (!isMobile) {
    leftVariant = {
      start: { x: -300, opacity: 0 },
      end: {
        x: 0,
        opacity: 1,
        transition: {
          delay: 0.5,
          duration: 1,
        },
      },
    };

    rightVariant = {
      start: {
        x: 50,
        opacity: 0,
      },
      end: {
        x: 0,
        opacity: 1,
        transition: {
          // delay: 0.5,
          duration: 1,
        },
      },
    };
  }

  return (
    <WS>
      <Modal
        width="max-content"
        showModal={showAggregatorForm}
        onBackdropClick={() => setShowAggregatorForm(!showAggregatorForm)}
        onCloseClick={() => setShowAggregatorForm(!showAggregatorForm)}
        maxModal
      >
        <BecomeAnAgentForm closeModal={setShowAggregatorForm} />
      </Modal>
      <div className="BecomeAnAgent__WS__WSS container">
        <motion.div
          variants={leftVariant}
          initial="start"
          whileInView="end"
          // transition={{ delay: 0.5, duration: 1 }}
          viewport={{ once: true }}
          className="BecomeAnAgent__WS__WSS--send-money"
        >
          <Typography.Heading
            className="landing--text-summary"
            color="pending"
            weight="medium"
            level={3}
            uppercase
            fontType="Galano"
          >
            Become an <br /> agent and help people
          </Typography.Heading>
          <Typography.Heading
            className="landing__heading"
            color="darkBlue"
            weight="medium"
            level={1}
            capitalize
            fontType="Galano"
          >
            Help People
          </Typography.Heading>
          <Typography.Text
            className="content-text"
            fontType="Galano Alt"
            weight="normal"
            level="large"
            color="subHeadingGrey"
            style={{
              lineHeight: "31px",
            }}
          >
            Earn a living helping hundreds of people in your community quickly
            and securely make cash withdrawals, transfers and pay bills.
          </Typography.Text>
          <a href="https://app.dotpay.africa/signup">
            <Button className="landing-btn" primary>
              <Typography.Text
                uppercase
                color="white"
                weight="medium"
                level="xlarge"
              >
                Become an agent
              </Typography.Text>
              <DPIconCircleRightArrow />
            </Button>
          </a>
        </motion.div>
        <motion.div
          variants={rightVariant}
          initial="start"
          whileInView="end"
          // transition={{ delay: 0.5, duration: 1 }}
          viewport={{ once: true }}
          className="BecomeAnAgent__WS__WSS--dp"
        >
          <img
            className="BecomeAnAgent__WS__WSS--dp-image"
            src="/assets/images/becomeAgent.png"
            alt=""
          />
          {/* <BtnFeatures />
          <Emage /> */}
        </motion.div>
      </div>
    </WS>
  );
};
const WS = styled.section`
  ${media.smallDesktopMin`padding:100px;`};
  @media screen and (max-width: 768px) {
    padding-top: 50px;
  }
  .BecomeAnAgent__WS {
    &__WSS {
      display: flex;
      flex-direction: column;
      &--send-money {
        width: 100%;
        padding: 60px 0;
        ${media.smallDesktopMin` max-width: 336px;`};
      }
      ${media.tabletMin`
        flex-direction: column;
        align-items: center;
        `};
      ${media.smallDesktopMin`
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        `};
      &--dp {
        /* position: relative; */
        &-image {
          max-width: 450px;
          width: 100%;
          ${media.smallDesktopMin`max-width: 535px;`};
        }
      }
    }
  }
`;

export default BecomeAnAgent;
